import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  InPersonEventConfirmationsParams,
  InPersonEventCheckInQrParams,
  CheckInUserResult,
  CheckInUser,
} from 'redux/schemas/api/in-person-event';
import t from 'react-translate';
import { makeQueryParamString } from './helpers';
import { addAlertMessage } from './alert-messages';
import { AlertMessageType } from '../schemas/app/alert-message';

export const getInPersonEventConfirmations = createAsyncThunk<
CheckInUser[],
InPersonEventConfirmationsParams
>(
  'GET_IN_PERSON_EVENT_CONFIRMATIONS',
  async ({ catalogId, sessionId, page, confirmed, searchBy }, { dispatch, rejectWithValue }) => {
    try {
      const paramString = makeQueryParamString({ page, pageSize: 15, searchBy: searchBy != null ? encodeURIComponent(searchBy) : searchBy, confirmed });
      const response = await axios.get(`${catalogId}/event_session/${sessionId}/attendees?${paramString}`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);

export const getInPersonEventCheckInQr = createAsyncThunk<
string,
InPersonEventCheckInQrParams
>(
  'GET_IN_PERSON_EVENT_CHECK_IN_QR',
  async ({ catalogId, sessionId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`${catalogId}/event_session/${sessionId}/qrcode`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);

export const inPersonEventConfirmAttendance = createAsyncThunk<
CheckInUserResult,
{ catalogId: string; sessionId: number }
>(
  'IN_PERSON_EVENTS_CONFIRM_ATTENDANCE',
  async ({ catalogId, sessionId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${catalogId}/event_session/${sessionId}/attendances`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);

export const inPersonEventCheckIn = createAsyncThunk<
CheckInUserResult,
{ catalogId: string; sessionId: number, passcode?: string, userId?: number }
>(
  'IN_PERSON_EVENTS_CHECK_IN',
  async ({ catalogId, sessionId, passcode, userId }, { dispatch, rejectWithValue }) => {
    try {
      const paramString = makeQueryParamString({ passcode });
      const url = `${catalogId}/event_session/${sessionId}/check_in${paramString ? `?${paramString}` : ''}`;
      const response = await axios.post(url, userId ? { userId } : undefined);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.FAILED(),
        message: t.LECTURE_PAGES.COMPONENTS.IN_PERSON_EVENTS.QR_CHECK_IN_ERROR(),
      }));
      return rejectWithValue(error);
    }
  },
);
